import  Petition  from "../../../modules/petition";

// /**
//  * Use Petition
//  * 
//  * You must use pet.get(url) or pet.post(url, data) 
//  */
// const pet = new Petition()

// export class apiService {
//   welcome(){
//     return 'welcome to ApiService';
//   }
//   example(){
//     return pet.get('http://api.150porciento.com/api/countries')
//   }
// }

const pet = new Petition()

export class apiService {
    async activities(){
        return await pet.get(`/get/actividades/destacadas`)
    }

    async indicators(){
        return await pet.get(`/instituciones/resumenindicadores`)
    }

    async activityDetail(id: String) {
        return await pet.get(`/get/actividades/detalle/${id}`)
    }

    async registedActivity(id: String) {
        return await pet.get(`/registred/${id}`)
    }

    async unsuscribeActivity(id: String) {
        return await pet.get(`/cancel/${id}`)
    }

    async deleteActivity(id: String) {
        return await pet.get(`/delete_activity/${id}`)
    }

    async header() {
        return await pet.get('/user/online/')
    }

    async activitiesInstitution() {
        return await pet.get('/get/actividades/institucion')
    }

    async getPhotosActivity(id: String) {
        return await pet.get(`/fotos/${id}`)
    }

    async getChallengeVolun() {
        return await pet.get('/retos-voluntario/info')
    }
}